const ELIGIBLE_ROLES = ['LANDLORD', 'BNB_HOST', 'AIRBNB_HOST', 'HOST'];

export const normalizeRole = (role) => {
  if (!role) return '';
  const upper = String(role).trim().toUpperCase().replace(/-/g, '_');
  if (upper === 'AIRBNB_HOST' || upper === 'HOST') return 'BNB_HOST';
  return upper;
};

export const shouldRequireSubscriptionGate = ({ role, hasActiveSubscription, subscriptionEnabled }) => {
  const normalizedRole = normalizeRole(role);
  if (!subscriptionEnabled) return false;
  if (hasActiveSubscription === true) return false;
  return ELIGIBLE_ROLES.includes(normalizedRole);
};
